<template>
  <section id="terms-and-conditions" class="container section">
    <div class="columns is-centered">
      <div class="column is-half-fullhd">
        <h1 class="title">{{ content.title }}</h1>
        <div v-for="(item, i) in content.items" :key="i" class="block">
          <h3 v-if="item.title">{{ item.title }}</h3>
          <div v-if="item.type == 'text'">
            <p>{{ item.text }}</p>
          </div>
          <div v-else-if="item.type == 'link'">
            <p>
              {{ item.link.pre }}
              <a :href="item.link.href">{{ item.link.name }}</a>
              {{ item.link.after }}
            </p>
          </div>
          <div v-else-if="item.type == 'list_num'">
            <p>
              {{ item.list.pre }}
            </p>
            <ol>
              <li v-for="(obj, k) in item.list.items" :key="k">
                <h4>{{ obj.title }}</h4>
                <p>
                  {{ obj.text }}
                </p>
              </li>
            </ol>
          </div>
          <div v-else-if="item.type == 'list'">
            <p>
              {{ item.list.pre }}
            </p>
            <ul>
              <li v-for="(value, k) in item.list.items" :key="k">
                <div v-if="value.type === 'link'">
                  {{ value.link.pre }}
                  <a :href="value.link.href">{{ value.link.name }}</a>
                </div>
                <span v-else>{{ value }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";

const { locale, messages } = useI18n();

const content = computed(() => {
  const currentLocale = locale.value;
  const localeMessages = messages.value?.[currentLocale];
  return localeMessages?.cookies?.page || [];
});
</script>

<style scoped lang="scss">
.block {
  margin-bottom: 1rem;
}
h1 {
  font-size: 2em;
  margin-bottom: 1em;
}

ol,
ul {
  padding-left: 20px;
}
ul {
  list-style-type: "– ";
}
a {
  color: var(--brand-color);
  text-decoration: underline;
}
.title {
  color: var(--font-color);
}
</style>
